<script lang="ts">
import { ChartOptions } from "chart.js";
import { Pie, mixins } from "vue-chartjs";
import { Component, Mixins, Prop } from "vue-property-decorator";

@Component({
  extends: Pie,
  mixins: [mixins.reactiveProp],
})
export default class CampaignsGraphPie extends Mixins(mixins.reactiveProp, Pie) {
  @Prop() readonly options!: ChartOptions;

  mounted(): void {
    
  }

  refreshChart(): void {
    if (!this.$refs.canvas) {
      return;
    }
    this.renderChart(this.chartData, this.options);
  }
}
</script>
